import { SVG } from '../svg';
import { IconProps } from '../types';

interface CircleXIconProps extends IconProps {
  variant?: 'filled' | 'outlined';
}

export function CircleXIcon({ variant = 'outlined', ...props }: CircleXIconProps): JSX.Element {
  const isFilled = variant === 'filled';

  return (
    <SVG {...props} colorTarget={isFilled ? 'fill' : 'stroke'}>
      <circle cx="12" cy="12" r="10" />
      <path d="m15 9-6 6" stroke={isFilled ? '#fff' : undefined} />
      <path d="m9 9 6 6" stroke={isFilled ? '#fff' : undefined} />
    </SVG>
  );
}
